module.exports = __webpack_public_path__ + "media/images/icons/docspin-logo-without-icon-94258199dcba56b076e88e9610c4e14d.svg";